import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { UserAuth } from '../context/AuthContext';
import '../styles/LastRead.css';
import { Link } from 'react-router-dom';
import logo from '../asset/logo.png';
import { SkipButton } from './SkipButton';

const LastRead = () => {
  const [savedAyat, setSavedAyat] = useState(null);
  const { user } = UserAuth();

  const getSavedAyat = async () => {
    try {
      if (user?.uid) {
        const userRef = doc(db, user.uid, 'Terakhir Baca');
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          const ayatData = docSnap.data();
          return ayatData;
        } else {
          console.log('Dokumen tidak ditemukan!');
        }
      }
    } catch (error) {
      console.error('Error saat mengambil data ayat:', error);
    }
  };

  const fetchSavedAyat = async () => {
    const ayatData = await getSavedAyat();
    setSavedAyat(ayatData);
  };

  useEffect(() => {
    fetchSavedAyat();
  }, [user, setSavedAyat]);

  if (!savedAyat) {
    return (
      <div className='last-read'>
        <div className='last-read__link'>
          <div className='last-read__container last-read__container__info'>
            <div className='last-read__container__left'>
              <img src={logo} alt='logo' className='last-read__logo' />
            </div>
            <div className='last-read__info'>
              <h2 className='last-read__title'>Terakhir dibaca</h2>
              <hr />
              <p>Data tidak ditemukan</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <SkipButton idName='#main-content' />
      <div className='last-read'>
        <Link
          to={`/detailSurat/${savedAyat.nama_latin}/${savedAyat.nomor_surat}/${savedAyat.nomor_ayat}`}
          className='last-read__link'
          id='main-content'
        >
          <div className='last-read__container'>
            <div className='last-read__container__left'>
              <img src={logo} alt='logo' className='last-read__logo' />
            </div>
            <div className='last-read__container__right'>
              <h2 className='last-read__title'>Terakhir dibaca</h2>

              <hr />
              <div className='last-read__nama'>
                <p className='last-read__latin'>{savedAyat.nama_latin}</p>
                <div className='last-read__barrier'>-</div>
                <p className='last-read__surah'> {savedAyat.nama_surah}</p>
              </div>
              <p className='last-read__ayat'>Ayat {savedAyat.nomor_ayat}</p>
              <p className='last-read__waktu'>
                {savedAyat.tanggal} ({savedAyat.waktu} WIB)
              </p>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default LastRead;
